module.exports = __webpack_public_path__ + "static/media/LogoFinal.4468b234.png";